import styled from 'styled-components';
import { ReactComponent as DecorationSvg } from '../../figures/graphics.svg';
import { Container as BaseContainer } from '../base';
import media from '../base/media';

export const Wrapper = styled.div`
	padding: 6rem 0;
`;

export const Container = styled(BaseContainer)`
	position: relative;
`;

export const Decoration = styled(DecorationSvg)`
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: -1;

	${media.desktopLarge`
		bottom: -15rem;
		left: -15rem;
	`}
`;
